// Journal d'audit (décisions du 05/10/2026, docs/features/14_JOURNAL_AUDIT.md).
// Chaque écriture d'un document audité (envois, destinataires, utilisateurs, sociétés, carnet,
// adresses de retour) porte le tampon d'auteur `last_change`. Sa forme est imposée par les
// règles Firestore (stampShapeOk) : toujours l'écrire complet, via stamp() ou withStamp().
import firebase from "firebase/compat/app";

let delegationId = null;

// Lit les claims de la session : en connexion déléguée, le jeton porte delegation_id (repris
// dans chaque tampon), delegated_by_email et delegation_exp. À appeler à chaque connexion.
export async function initAuditSession(user) {
  delegationId = null;
  if (!user) return { delegationId: null };
  try {
    const result = await user.getIdTokenResult();
    const claims = result.claims || {};
    delegationId = claims.delegation_id || null;
    return {
      delegationId,
      delegatedByEmail: claims.delegated_by_email || null,
      expiresAt: claims.delegation_exp ? claims.delegation_exp * 1000 : null,
      authTime: result.authTime || null,
    };
  } catch (e) {
    console.error("Lecture de la session impossible", e);
    return { delegationId: null };
  }
}

// Identifiant d'opération : relie dans le journal les écritures d'une même action
// (un envoi et ses destinataires, une adresse appliquée et enregistrée au carnet…)
export function newOpId() {
  return firebase.firestore().collection("audit_logs").doc().id;
}

export function stamp({ op = null, intent = null } = {}) {
  const user = firebase.auth().currentUser;
  return {
    by: firebase
      .firestore()
      .collection("users")
      .doc(user ? user.uid : "_"),
    at: firebase.firestore.FieldValue.serverTimestamp(),
    delegation: delegationId,
    via: "web",
    op,
    intent,
    actor_type: "user",
  };
}

export function withStamp(data, options) {
  return { ...data, last_change: stamp(options) };
}

// Suppression tracée : pré-tampon « delete » puis suppression. Les règles exigent un
// pré-tampon du même auteur, posé il y a moins de 5 minutes.
export async function auditedDelete(ref, options = {}) {
  await ref.update({ last_change: stamp({ ...options, intent: "delete" }) });
  return ref.delete();
}

// Trace la connexion (IP, navigateur) une fois par authentification ; le serveur dédoublonne
// aussi sur auth_time. Rien en connexion déléguée (tracée à son ouverture).
export function recordSignIn(user, session) {
  if (!user || !session || session.delegationId) return;
  const key = `audit_signin_${user.uid}_${session.authTime || ""}`;
  try {
    if (window.sessionStorage.getItem(key)) return;
    window.sessionStorage.setItem(key, "1");
  } catch (e) {
    // Stockage indisponible (navigation privée) : le serveur dédoublonne
  }
  firebase
    .app()
    .functions("europe-west1")
    .httpsCallable("recordSignIn")()
    .catch((e) => console.error("Traçage de la connexion impossible", e));
}
